import script from "./cost-and-quantity.vue?vue&type=script&setup=true&lang=js"
export * from "./cost-and-quantity.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__